import { render, staticRenderFns } from "./FDecimal.vue?vue&type=template&id=1932f280&"
import script from "./FDecimal.vue?vue&type=script&lang=js&"
export * from "./FDecimal.vue?vue&type=script&lang=js&"
import style0 from "./FDecimal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports